<template>
  <div title="Get ready to meet your ideal agent">
    <div v-if="typeof saveResponse.id === 'undefined'" class="spinner-div">
      <b-spinner class="text-primary spinner" label="Loading..."></b-spinner>
      <div class="spinner-label">Please stand by while we process ...</div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col verbiage">
          <h3 class="bold">Thank you!</h3>
        </div>
      </div>
      <div class="row verbiage">
        <div class="col">
          <div class="fw-400 mb-1 center-80 thank-you-message">
            <span v-if="saveResponse.success" class="response-message" data-success="new-client" :data-id="saveResponse.id">Thanks for reaching out to IDEAL AGENT.</span>
            <span v-else class="response-message" data-success="current-client" :data-id="saveResponse.id">Got it!</span>
            Our team will review your inquiry and get in touch soon.
          </div>
        </div>
      </div>
      <div class="row verbiage">
        <div class="center-80 thank-you-message" style="margin-top:1rem;text-align:left;padding-left:1rem;">Here's what to expect next:</div>
      </div>
      <div class="row verbiage next-steps">
        <div>
          <h4><span>1.</span>Confirmation</h4>
          <p>You'll receive email and text confirmation of your form submission. If the email doesn't appear in your inbox, check your spam folder.</p>
        </div>
        <div>
          <h4><span>2.</span>Initial Call</h4>
          <p>If within our business hours, you’ll promptly receive a call from one of our dedicated team members to discuss your selling and/or buying 
            needs. If after hours, we’ll give you a call the following day. Be ready to answer basic questions regarding your home or property.</p>
        </div>
        <div>
          <h4><span>3.</span>Connect with a Top Local Agent</h4>
          <p>One of our dedicated team members will connect you with the best agent in your local area that will get you the best results all for as low as a 2% commission.</p>
        </div>
        <div>
          <h4><span>4.</span>We’re Here to Help</h4>
          <p>Our agent takes it from here, but our team is always available to ensure that you have a 5-Star experience.</p>
        </div>
      </div>
      <table class="business-hours">
        <tr>
          <td class="title" colspan="2">
            Business Hours
          </td>
        </tr>
        <tr>
          <td>Monday - Friday</td>
          <td>9 am - 8 pm EST</td>
        </tr>
        <tr>
          <td>Saturday - Sunday</td>
          <td>10 am - 7 pm EST</td>
        </tr>
      </table>
      <div class="row verbiage">
        <div class="col">
          <h4>In the meantime, check out our 5-star reviews on <a
              href="https://www.trustpilot.com/review/idealagent.com" target="_blank">Trust Pilot</a> <br/>or
            go back to our <a href="/">home page</a>.</h4>
        </div>
      </div>
      <div class="ad">
        <img
          src="https://static.idealagent.com/web/banners/ideal-agent_display_ad_2.png"
          alt="Buy and Sell with Confidence"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {saveMarketing, getConversionHtmlPage} from "@/services/apiService";

export default {
  name: "YourAgent",
  props: ['source', 'type', 'saveResponse'],
  data() {
    return {
      marketing: null
    }
  },
  methods: {
    populateMarketing: function (value) {
      this.marketing = value;
      saveMarketing('Lead_Source', this.marketing);
    }
  },
  computed: {
    marketingPopulated: function () {
      return !this.isEmpty(this.marketing);
    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    let source = this.source;

    let response = await getConversionHtmlPage(source);
    let htmlSource = response ? response.data : false;

    if (htmlSource) {
      let iframe = document.createElement('iframe');
      iframe.style.display = "none";
      document.body.appendChild(iframe);
      let doc = iframe.contentWindow.document;
      doc.open();
      doc.write(htmlSource);
      doc.close();
    }
  }
}
</script>

<style scoped>
.spinner-div {
  display:flex;
  min-height:50vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.spinner {
  width: 3rem;
  height: 3rem;
}
.spinner-label {
  padding-top: 1em;
}
h3 {
  font-size: 3em;
}
.thank-you-message {
  font-size: 1.25em;
  max-width:601px;
}
.next-steps {
  max-width: 600px;
  margin:0 auto;
  padding: 1rem;
  text-align: left;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}
.next-steps h4 {
 margin:.25rem .25rem 1rem .25rem;
}
.next-steps h4 > span {
  margin-right: 1rem;
}
.business-hours {
  margin: 0 auto;
  margin-bottom: 1.5rem;
}
.business-hours td.title {
  text-align: center !important;
  font-weight: bold;
  padding-bottom: .5rem;
}
table.business-hours td {
  text-align: left;
  padding: 0 .5rem;
}
table.business-hours tr td:first-child {
  text-align: right
}

.verbiage {
  margin-bottom: 1em;
}

.button-row {
  margin: auto;
  left: 0;
  right: 0;
  padding: 10px;
}

.button {
  margin: auto;
  left: 0;
  right: 0;
  padding: 10px;
  margin: 10px;
  width: 175px;
}

.headline {
  font-size: 1.5em;
  text-align: left;
}

.ad {
  text-align: center;
  padding-top: 50px;
  margin: 0 auto;
}

.ad img {
  width:100%;
  max-width:630px;
}
</style>
